import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { IUsuarioCambiarPasswordModel } from 'src/app/models/interfaces/seguridad/IUsuarioCambiarPasswordModel';
import { UsuarioCambiarPasswordModel } from 'src/app/models/seguridad/UsuarioCambiarPasswordModel';
import { AutenticacionService } from 'src/app/services/seguridad/autenticacion/autenticacion.service';
import { SeguridadUsuarioService } from 'src/app/services/seguridad/seguridad-usuario.service';
import { AlertDialogService } from 'src/app/services/alert-dialog/alert-dialog.service';

@Component({
  selector: 'app-cambiar-contrasena',
  templateUrl: './cambiar-contrasena.component.html',
  styleUrls: ['./cambiar-contrasena.component.css']
})
export class CambiarContrasenaComponent implements OnInit {
  hideContrasenaActual = true;
  hideNuevaContrasena = true;
  hideConfirmarContrasena = true;
  model: IUsuarioCambiarPasswordModel;

  constructor(
    private seguridadUsuarioService: SeguridadUsuarioService,
    private alertDialogService: AlertDialogService,
    private router: Router
  ) { 
    this.model = new UsuarioCambiarPasswordModel();
  }

  ngOnInit(): void {
  }

  submit(){
    if (this.model.newPassword=='' || this.model.oldPassword=='') {
      
        this.alertDialogService.open('Debe ingresar los campos requeridos');
    }else{
    this.seguridadUsuarioService.cambiarPassword(this.model).subscribe((data) => {
      this.alertDialogService.open('Se actualizó su contraseña satisfactoriamente.'); //options
          this.router.navigate(['/']);
      console.log(data);
    });
  }
  }
}
